import { cn } from '@/lib/utils'

type Props = {
  children: React.ReactNode
  className?: string
}
export const CopperDenimContainer: React.FC<Props> = ({
  children,
  className,
  ...props
}) => {
  return (
    <section className={cn('px-4 py-10 lg:px-15', className)} {...props}>
      {children}
    </section>
  )
}
